import { LazyLoad } from 'app/utils';

export const InfoListPage = LazyLoad(
  () => import('./index'),
  (module) => module.InfoListPage,
);
